import { J as JS_PREFIX } from './built-constants-439d5572.js';
import './built-ajax-api-4ab76389.js';
import './built-cart-event-emitter-def8079a.js';
import './built-env-utils-ed419642.js';
import './built-config-a65ae98c.js';
import './built-clsx.m-cb13ff27.js';
import './built-init-1bb12f92.js';
import './built-loglevel-42c63e3e.js';
import './built-price-format-dc3d77ee.js';
import './built-error-message-utilities-4ca13134.js';
import './built-on-add-to-cart-59888dcc.js';
import './built-make-request-bc649a18.js';
import './built-element-utils-09877efc.js';
import './built-slick-carousel-807ba140.js';
import { i as init } from './built-init-5cb6802e.js';

var _window$DY;
/**
 * Wait for DY to be ready
 *
 * @see https://support.dynamicyield.com/hc/en-us/articles/360007232477-Wait-for-Element-Client-Side-APIs#wait-for-dynamic-yield-script-0-3
 */

(_window$DY = window.DY) == null ? void 0 : _window$DY.API == null ? void 0 : _window$DY.API('callback', () => {
  document.querySelectorAll("." + JS_PREFIX + "DYProductTileCarousel").forEach(dyProductTileCarouselEl => {
    // Using a try/catch with console.error allows subsequent widgets to still
    // initialize even if the first one errors out
    try {
      init("#" + dyProductTileCarouselEl.id);
    } catch (error) {
      console.error(error);
    }
  });
});
